import BadgesModel from "../Badges/BadgesModel";
import PointsModel from "../Points/PointsModel";
import TiersModel from "../Tiers/TiersModel";

export default class RewardsModel {
    public points: PointsModel = null;
    public tiers: TiersModel[] = null;
    public badges: BadgesModel = null;
}